"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genDirectoryStyle = void 0;
// ============================ Directory =============================
var genDirectoryStyle = function genDirectoryStyle(_ref) {
  var treeCls = _ref.treeCls,
    treeNodeCls = _ref.treeNodeCls,
    directoryNodeSelectedBg = _ref.directoryNodeSelectedBg,
    directoryNodeSelectedColor = _ref.directoryNodeSelectedColor,
    motionDurationMid = _ref.motionDurationMid,
    borderRadius = _ref.borderRadius,
    controlItemBgHover = _ref.controlItemBgHover;
  return _defineProperty({}, "".concat(treeCls).concat(treeCls, "-directory ").concat(treeNodeCls), _defineProperty(_defineProperty(_defineProperty({}, "".concat(treeCls, "-node-content-wrapper"), _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    position: 'static'
  }, "> *:not(".concat(treeCls, "-drop-indicator)"), {
    position: 'relative'
  }), '&:hover', {
    background: 'transparent'
  }), '&:before', {
    position: 'absolute',
    inset: 0,
    transition: "background-color ".concat(motionDurationMid),
    content: '""',
    borderRadius: borderRadius
  }), '&:hover:before', {
    background: controlItemBgHover
  })), "".concat(treeCls, "-switcher"), {
    marginInlineEnd: 0
  }), '&-selected', _defineProperty(_defineProperty({}, "".concat(treeCls, "-switcher, ").concat(treeCls, "-draggable-icon"), {
    color: directoryNodeSelectedColor,
    zIndex: 1
  }), "".concat(treeCls, "-node-content-wrapper"), {
    color: directoryNodeSelectedColor,
    background: 'transparent',
    '&:before, &:hover:before': {
      background: directoryNodeSelectedBg
    }
  })));
};
exports.genDirectoryStyle = genDirectoryStyle;